import { configureStore } from '@reduxjs/toolkit';
import pageReducer from '../features/pagecount/pageSlice';
import filterReducer from '../features/fliter/filterSlice';
import filterReducerVendor from '../features/fliter/filterSliceVendor';
import pageHandle from '../features/pageHandle';

const store = configureStore({
    reducer: {
        page: pageReducer,
        filter: filterReducer,
        filterVendor: filterReducerVendor,
        pageHandler: pageHandle
    }
});

export default store;
